export default {
  // changeCity (state, city){
  //   state.city = city
  //   try {
  //     localStorage.city = city
  //   } catch (e) {}

  // },

  setAccountInfo(state, loginInfo) {
    state.loginInfo = loginInfo;
    try {
      localStorage.accountInfo = JSON.stringify(loginInfo);
    } catch (e) {}
  },

  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
    try {
      localStorage.setItem("USER_INFO", JSON.stringify(userInfo));
    } catch (e) {}
  },

  setCookieNoticeShow(state, value) {
    state.cookieNoticeShow = value;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js